module.exports = __webpack_public_path__ + "media/images/icons/country_flags/bo-2df6927ff85d4a69996b625b5f837879.svg";